// Public-facing project links. Safe to commit: the repo and the deployed site
// are both public. Infra details (VM, tunnel, creds) never live here.
export const REPO_URL = 'https://github.com/LucaLiverani/mylife-in-data';
export const SITE_URL = 'https://mylife-in-data.com';
export const AUTHOR = 'Luca Liverani';
